import './styles.scss';

export default {
    name: 'StampModeDropdown',
    
    data() {
        return  {
            opacity: 0.5,
            stamp: {},
            stamps: []
        };
    },

    methods: {
        chooseOpacity(opacity) {
            this.opacity = opacity;
            this.$ionic.popoverController.dismiss({ 
                opacity: this.opacity,
                stamp: this.stamp
            });
        },
        
        chooseStamp(stamp) {
            this.stamp = stamp.id;
            this.$ionic.popoverController.dismiss({ 
                opacity: this.opacity,
                stamp: stamp
            });
        }
    }
};